import { render, staticRenderFns } from "./ScienceIcon.vue?vue&type=template&id=73aefc3e&scoped=true&"
import script from "./ScienceIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ScienceIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aefc3e",
  null
  
)

export default component.exports